import { defineStyle, defineStyleConfig } from '@chakra-ui/react'

const sizes = defineStyle({
  '3xs': defineStyle({
    textStyle: '3xs',
  }),
  '2xs': defineStyle({
    textStyle: '2xs',
  }),
  xs: defineStyle({
    textStyle: 'xs',
  }),
  sm: defineStyle({
    textStyle: 'sm',
  }),
  md: defineStyle({
    textStyle: 'md',
  }),
  lg: defineStyle({
    textStyle: 'lg',
  }),
  xl: defineStyle({
    textStyle: 'xl',
  }),
  '2xl': defineStyle({
    textStyle: '2xl',
  }),
  '3xl': defineStyle({
    textStyle: '3xl',
  }),
  '4xl': defineStyle({
    textStyle: '4xl',
  }),
  '5xl': defineStyle({
    textStyle: '5xl',
  }),
  '6xl': defineStyle({
    textStyle: '6xl',
  }),
})

export const Text = defineStyleConfig({
  sizes,
  defaultProps: {
    size: 'md',
  },
})
